/**
 * 对象类型数据操作的工具函数（包括数组）
 */

type IObject<T = any> = Record<string, T>;
type IList<T = any> = T[];
const empties = ['', null, undefined];

// 判断对象是否全部为空
export const isAllEmpty = (obj: IObject) => {
  return Object.keys(obj).every((key) => {
    const val = obj[key];
    return empties.indexOf(val) > -1;
  });
};

// 去掉对象里的空值字段
export const filterEmpty = (obj: IObject) => {
  return Object.keys(obj).filter((key) => !empties.includes(obj[key])).reduce((acc, cur) => {
    acc[cur] = obj[cur];
    return acc;
  }, {} as Partial<IObject>);
};

// 对象数组按指定字段去重
// 即将废弃. 使用 ./filters.ts 里的 deduplicate
export const uniqueList = (list: IList, field: string) => {
  const result = {} as IObject;
  return list.reduce<IList>((acc, cur) => {
    const key = cur[field];
    if (!result[key]) {
      result[key] = true;
      acc.push(cur);
    }
    return acc;
  }, []);
};

// 纯数组去重
export const noRepeatList = <T = any>(list: T[]) => {
  return list.reduce((acc, cur) => acc.indexOf(cur) === -1 ? [...acc, cur] : [...acc], [] as T[]);
};

// 将数组按指定字段的值转换为对象
export const groupedList = <T = IObject>(list: T[], field: string) => {
  return list.reduce((acc, cur) => {
    const key = (cur as IObject)[field];
    if (!acc[key]) {
      acc[key] = [cur];
    } else {
      acc[key].push(cur);
    }
    return acc;
  }, {} as Record<string, T[]>);
};

// 将一维数组构造为树形数组
export const buildTree = (list: IList, key = 'id', parent = 'parentId', child = 'children') => {
  const tree = [] as any[];
  const map = {} as Record<string, any[]>;
  for (const item of list) {
    const id = item[key];
    const pid = item[parent];
    if (!id) {
      continue;
    }
    if (!map[id]) {
      map[id] = [];
    }
    item[child] = map[id];
    if (!pid) {
      tree.push(item);
      continue;
    }
    if (!map[pid]) {
      map[pid] = [];
    }
    map[pid].push(item);
  }
  return tree;
};

// 将树形数组展平为一维数组(存放子节点的字段为 children)
export const flattenTree = (tree: IList) => {
  return tree.reduce<any[]>((acc, cur) => {
    const { children, ...rest } = cur;
    acc = [...acc, rest];
    if (children && children.length) {
      acc = [...acc, ...flattenTree(children)];
    }
    return acc;
  }, []);
};
